<script setup lang="ts">
interface Props {
    message?: string;
    type?: 'warning' | 'info' | 'error';
}

withDefaults(defineProps<Props>(), {
    message: '',
    type: 'warning',
});

const ICON_COLOURS = {
    warning: '#B45309', // amber 700: the white "!" is about 5:1 on it (amber 500 was 2:1)
    info: '#2E46B9', // es-ds blue 600: the white "!" is about 7.8:1 on it
    error: '#D32F2F', // quote-edit's error red
};
</script>

<template>
    <div
        class="info-message"
        :class="type"
        :role="type === 'info' ? 'status' : 'alert'">
        <div class="icon">
            <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle
                    cx="10"
                    cy="10"
                    r="10"
                    :fill="ICON_COLOURS[type]" />
                <text
                    x="10"
                    y="15"
                    font-size="14"
                    font-weight="bold"
                    fill="white"
                    text-anchor="middle"
                    font-family="Arial, sans-serif">
                    !
                </text>
            </svg>
        </div>
        <div class="message-text">
            <slot>{{ message }}</slot>
        </div>
    </div>
</template>

<style scoped lang="scss">
.info-message {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 4px;
    margin-top: 12px;
    margin-bottom: 24px;
    background-color: #ffffff;
    border: 1px solid #e5e7eb;

    &.info {
        background-color: #ffffff;
        border: 1px solid #e5e7eb;
    }

    &.warning {
        border-color: #b45309;
    }

    &.error {
        border-color: #d32f2f;
    }

    .icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        margin-top: 2px;
    }

    .message-text {
        flex: 1;
        font-size: 14px;
        line-height: 1.5;
        color: #374151;
    }
}
</style>
